import ApiGael from "@/services/apiGael.service";
import { FETCH_ALL } from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END
} from "@/store/mutations/mutations.type";

const state = {
  areaDeAtuacoes: {
    data: [],
    filters: []
  },
  isFetchingAreaDeAtuacoes: false
};

const getters = {
  areaDeAtuacoes(state) {
    return state.areaDeAtuacoes;
  },
  isFetchingAreaDeAtuacoes(state) {
    return state.isFetchingAreaDeAtuacoes;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiGael.query("areaDeAtuacoes/list", params)
        .then(response => {
          if (!params) {
            context.commit(SET_ALL, {
              areaDeAtuacoes: response.data
            });
          } else {
            context.commit(SET_ALL, {
              areaDeAtuacoes: response.data,
              lazyLoad: params.lazyLoad
            });
          }
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingAreaDeAtuacoes = true;
  },
  [SET_ALL](state, payload) {
    if (payload.lazyLoad) {
      payload.areaDeAtuacoes.data = state.areaDeAtuacoes.data.concat(
        payload.areaDeAtuacoes.data
      );
    }

    state.areaDeAtuacoes.data = payload.areaDeAtuacoes;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingAreaDeAtuacoes = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
